import React from 'react'

import { Field } from 'react-form'

import { InputText } from 'primereact/inputtext'

import FieldMessage from './FieldMessage'

import { validateFromRule, getRuleForField } from '../../js/validation'

import '../../css/field.css'

// this ia wrapper function for the prime react input text so it can work with react-form's form object
// make sure it is used with Form tags
// this allows the value of the form to read and updated in the form

// the reason this is done is because prime react's components are examples of controlled components
// they have a value set that binds to the state or props so that when that state or props is udated the component is re-rendered
// the onChange of the component needs to be handled to update the value of the state or props otherwise the user input will not be picked up
// use react-form's setValue function will update the state of the field on the form so that changes will be reflected

// pass in the field as the property name to bind and the label as what is displayed
// showAsTextOnly is used to disable the component, hide the component styling and make it look like text only
/*
  <Form>
  {formApi => {
    return (
      <div className=""p-grid">
        <div className="p-col-12">
            <FieldInputText field={"Position"} label={"Position"} validationRules={validationRules} showAsTextOnly={showAsTextOnly}/>
        </div>
      </div>
    )}
  }
  </Form>
*/
class FieldInputText extends React.Component {
  render() {
    let validationRule = {}
    if (this.props.validationRules) {
      validationRule = getRuleForField(this.props.validationRules, this.props.field)
    }

    // check disbaled state and pass to the Field component
    // this is done because the pure prop for the field component is defaulted to true so it will only re render
    // when props change. Since we are passing in a custom child component we want that to re render when props it depends on update
    // however the react-form Field component checks on props passed to itself not what the children depend on so to force a re render
    // when the child component disabled state changes we need to pass in the prop to the field component. This should be extended to all props
    // that might need to cause the child component to re render
    // https://react-form.js.org/#/form-inputs
    let isDisabled = this.props.showAsTextOnly === true || this.props.disabled === true
    return (
      // Use the form field and your custom input together to create your very own input!
      // field is the property name that is bound to in the form
      // validate is a function used to validate the field
      <Field field={this.props.field} validate={this.validate} isDisabled={isDisabled}>
        {fieldApi => {
          // fieldApi properties can found at https://react-form.js.org/#/custom-input
          // Remember to pull off everything you dont want ending up on the element otherwise it will throw errors
          // this extracts things out of the props passed in and leaves ...rest to be the rest of the properties
          // this way can pass in the extra properties to the prime react component
					const { onBlur, onChange, validate, field, validationRules, showAsTextOnly, showLabel, autoFocus, autoComplete, label, setValueAsUpperCase, inputStyle, tooltip, ...rest } = this.props
					// value and setValue read and update value in the form
					const { value, setValue, setTouched, error, warning, success } = fieldApi
          let setFieldToUpcase =   setValueAsUpperCase ? true :false;
					let hasValidationRule = typeof validationRule !== "undefined"
					let isRequired = hasValidationRule && validationRule.IsRequired === true
          let hasAutofocus = autoFocus === "true"
          let id = field
          let idError = field + '_error'
          let labelHtml = ""
          if(showLabel !== "false")
          {
            labelHtml = <div className="p-col-12 field-label-container">
              <label aria-label={this.props.label} htmlFor={id}> 
                {this.props.label}
                {isRequired === true && <span className="required-field-label"></span>}
              </label>
            </div>
          }


					return (
						<div className="p-grid">
              {labelHtml}
							<div className="p-col-12 field-element-container">
								<InputText {...rest} value={value || ''} tooltip={tooltip} id={id} aria-describedby={idError}
                  style={inputStyle} autoFocus={hasAutofocus} autoComplete={autoComplete}
                  
                  className={showAsTextOnly ? 'show-text-only' : ''}
                  disabled={showAsTextOnly || rest.disabled}
                  onChange={e => {
                    if (onChange) { onChange(e) }
                     let fieldValue =    setFieldToUpcase ? e.target.value.toUpperCase() : e.target.value
                     setValue(fieldValue)
                  }}
                  onBlur={e => {
                    setTouched()
                    if (onBlur) {
                      onBlur(e)
                    }
                  }}
                />
              </div>
              {(error || warning || success) && <div className="p-col-12"  role="alert">
                {error ? <FieldMessage color="#B30000" message={error}  id={idError} /> : null}
                {!error && warning ? <FieldMessage color="orange" message={warning} /> : null}
                {!error && !warning && success ? <FieldMessage color="green" message={success} /> : null}
              </div>}
            </div>
          )
        }}
      </Field>
    )
  }

  /*
    generic validation handler for input field
    checks the validation rules
    TODO - optional validation passed in as a props
  */
  validate = value => {
    let validationResult = {}
    let validationRule = {}
    if (this.props.validationRules) {
      validationRule = getRuleForField(this.props.validationRules, this.props.field)
      if (validationRule) {
        validationResult = validateFromRule(validationRule, value)
      }
    } else {
      validationResult.success = ''
    }
    return validationResult
  }
}

export default FieldInputText;



// WEBPACK FOOTER //
// ./src/components/common/FieldInputText.js